
import { getIsAppFactRender } from './is-app-fact';
import { getIsLoginFactRender } from './is-login-fact';
import { getIsSetupFactRender } from './is-setup-fact';
import { getVarFactRender } from './var-fact';
import { getUdpFactRender } from './udp-fact';
import { getAreaFactRender } from './area-fact';
import { getAbtFactRender } from './abt-fcat';

import { resetRequestCache } from './impl-helper';



export const facts = {};


export const registerFact = (factId, factRender) => {
    //对于factRender，进行统一的包装，包装成async函数，方便后续扩展，并在前后添加日志和异常处理
    //这样处理的另一个原因因为内部factRender如果发生错误那么会导致整个rule执行失败，现在规则是执行失败就当做false处理
    const factRenderWrapper = async (params, almanac) => {
        console.log('[fego-condition][before]factRenderWrapper', factId, params, almanac);
        let res = false;
        try {
            res = await factRender(params, almanac);
        } catch (e) {
            console.error('[fego-condition][error]factRenderWrapper', factId, e);
        }
        console.log('[fego-condition][after]factRenderWrapper', factId, params, res);
        return res;
    };
    facts[factId] = factRenderWrapper;
};

export const init = (options = {}) => {
    const { clearCache = false } = options;

    if (clearCache) {
        resetRequestCache();
    }

    registerFact('is-app-fact', getIsAppFactRender);
    registerFact('is-login-fact', getIsLoginFactRender);
    registerFact('is-setup-fact', getIsSetupFactRender);
    registerFact('var-fact', getVarFactRender);
    registerFact('udp-fact', getUdpFactRender);
    registerFact('area-fact', getAreaFactRender);
    registerFact('abt-fact', getAbtFactRender);

    return facts;
};
